<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="map"><span class="epub-b">MAPS</span></p>
<p class="img-br"><img alt="image" height="600" src="images/pgx.jpg" width="557"/></p>
<p class="img-br"><img alt="image" height="600" src="images/pgxi.jpg" width="560"/></p>
<p class="img-br"><img alt="image" height="600" src="images/pgxii.jpg" width="539"/></p>
<p class="img-br"><img alt="image" height="600" src="images/pgxiii.jpg" width="537"/></p>
<p class="cap">Two dams that changed the Nile forever</p>
<p class="img"><img alt="image" height="600" src="images/pgxiv.jpg" width="541"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?23181598